module.exports = __webpack_public_path__ + "static/img/landing_background_triangle.d17f72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/landing_background_triangle.png
// module id = MVUg
// module chunks = 0